import React, { useState } from 'react';
import { Button, Modal, Header, Form, Icon, Dimmer, Loader } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

const NewsletterOptIn = ({ userEmail }) => {
    const [open, setOpen] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleYes = async () => {
        setLoading(true);

        try {
            // Call your Rails API to create a new contact in Sendinblue
            const response = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: userEmail, decide: true }),
            });

            if (!response.ok) {
                throw new Error('Error creating contact in Sendinblue');
            }

            // Close the modal on success
            setOpen(false);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleNo = async () => {
        setLoading(true);

        try {
            // Call your Rails API to create a new contact in Sendinblue
            const response = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: userEmail, decide: false }),
            });

            if (!response.ok) {
                throw new Error('Error creating contact in Sendinblue');
            }

            // Close the modal on success
            setOpen(false);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} size="tiny" onClose={handleNo} centered>
            <Header>
                <Icon name="envelope" /> Subscribe to our newsletter?
            </Header>
            <Modal.Content>
                <Dimmer active={loading} inverted>
                    <Loader>Loading</Loader>
                </Dimmer>
                <Form>
                    <Form.Input
                        label="Email"
                        type="email"
                        value={userEmail}
                        readOnly
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button color="green" onClick={handleYes} loading={loading}>
                    Yes
                </Button>
                <Button color="red" onClick={handleNo} disabled={loading}>
                    No
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default NewsletterOptIn;
